import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-2" }
const _hoisted_3 = { class: "form-check form-switch custom-switch-md" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = {
  key: 0,
  class: "overflow-hidden ps-3"
}
const _hoisted_6 = { class: "bg-light rounded-2 p-3 border animate-fade-in mb-2" }
const _hoisted_7 = { class: "row g-2 align-items-end" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "input-group input-group-sm shadow-sm" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-12 mt-2" }
const _hoisted_14 = {
  class: "text-muted small",
  style: {"font-size":"0.7rem"}
}
const _hoisted_15 = {
  key: 0,
  class: "text-muted small ms-3 ps-3 border-start border-3",
  style: {"font-size":"0.75rem"}
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelKickConfig',
  props: {
  kickUsers: { type: Boolean, default: false },
  kickAfter: { type: Number, default: 7 },
  kickAfterUnit: { type: String, default: "day" },
},
  emits: ["update:kickUsers", "update:kickAfter", "update:kickAfterUnit"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "fw-bold text-dark mb-0" }, [
        _createElementVNode("i", { class: "fas fa-user-clock fa-fw me-2 text-danger" }),
        _createTextVNode("Expulsión Automática ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          checked: __props.kickUsers,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$emit(
              'update:kickUsers',
              ($event.target as HTMLInputElement).checked
            )
          )),
          class: "form-check-input cursor-pointer success",
          type: "checkbox",
          id: "kickUsersSwitch"
        }, null, 40, _hoisted_4)
      ])
    ]),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        (__props.kickUsers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, "Expulsar tras Expiración +", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0 text-muted" }, [
                        _createElementVNode("i", { class: "fas fa-hourglass-end" })
                      ], -1)),
                      _createElementVNode("input", {
                        value: __props.kickAfter,
                        onInput: _cache[1] || (_cache[1] = ($event: any) => (
                    _ctx.$emit(
                      'update:kickAfter',
                      Number(($event.target as HTMLInputElement).value)
                    )
                  )),
                        type: "number",
                        class: "form-control bg-white border-start-0 text-center",
                        min: "0",
                        required: "",
                        style: {"border-left":"0"}
                      }, null, 40, _hoisted_10)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, "Unidad de Tiempo", -1)),
                    _createElementVNode("select", {
                      value: __props.kickAfterUnit,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (
                  _ctx.$emit(
                    'update:kickAfterUnit',
                    ($event.target as HTMLSelectElement).value
                  )
                )),
                      class: "form-select form-select-sm bg-white shadow-sm",
                      required: ""
                    }, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("option", { value: "day" }, "Días", -1),
                      _createElementVNode("option", { value: "week" }, "Semanas", -1),
                      _createElementVNode("option", { value: "month" }, "Meses", -1),
                      _createElementVNode("option", { value: "year" }, "Años", -1)
                    ]))], 40, _hoisted_12)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("small", _hoisted_14, [
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                      _cache[9] || (_cache[9] = _createTextVNode(" El usuario será expulsado automáticamente del canal ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(__props.kickAfter) + " " + _toDisplayString(__props.kickAfterUnit === "day"
                      ? "días"
                      : __props.kickAfterUnit === "week"
                      ? "semanas"
                      : __props.kickAfterUnit === "month"
                      ? "meses"
                      : "años"), 1),
                      _cache[10] || (_cache[10] = _createTextVNode(" después de que su suscripción expire o deje de cumplir los requisitos. ", -1))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!__props.kickUsers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Activa esta opción para que el sistema expulse automáticamente a los usuarios que pierdan su membresía o rango. "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})